import { C } from './colors';

// Chip backgrounds use .18 alpha for a vibrant look on the #0a1528 dark surface —
// matches the old-design reference (saturated fills, not washed-out). Single
// canonical alpha for every status map so tone stays consistent across pages.
export const STATUS_MAP = {
  // Title-case display variants
  "On Track":   { fg:C.green,  bg:C.greenB  },
  "At Risk":    { fg:C.yellow, bg:C.yellowB },
  "Critical":   { fg:C.red,    bg:C.redB    },
  "On Hold":    { fg:C.sub,    bg:"rgba(143,164,200,.18)" },
  "Completed":  { fg:C.green,  bg:C.greenB  },
  "Submitted":  { fg:C.green,  bg:C.greenB  },
  "Pending":    { fg:C.sub,    bg:"rgba(143,164,200,.18)" },
  "Overdue":    { fg:C.red,    bg:C.redB    },
  "T&M":        { fg:C.blue,   bg:C.blueB   },
  "Fixed Fee":  { fg:C.purple, bg:C.purpleB },
  // Prisma enum variants (UPPERCASE_SNAKE)
  "ON_TRACK":   { fg:C.green,  bg:C.greenB  },
  "AT_RISK":    { fg:C.yellow, bg:C.yellowB },
  "CRITICAL":   { fg:C.red,    bg:C.redB    },
  "ON_HOLD":    { fg:C.sub,    bg:"rgba(143,164,200,.18)" },
  "COMPLETED":  { fg:C.green,  bg:C.greenB  },
  "SUBMITTED":  { fg:C.green,  bg:C.greenB  },
  "PENDING":    { fg:C.sub,    bg:"rgba(143,164,200,.18)" },
  "OVERDUE":    { fg:C.red,    bg:C.redB    },
  "TIME_AND_MATERIALS": { fg:C.blue,   bg:C.blueB   },
  "FIXED_FEE":          { fg:C.purple, bg:C.purpleB },
  "PRE_INVOICING":      { fg:C.yellow, bg:C.yellowB },
};

export const GROWTH_MAP = {
  "STABLE":           { fg:"#10c981", bg:"rgba(16,201,129,.18)" },
  "NEEDS_ATTENTION":  { fg:"#f59e0b", bg:"rgba(245,158,11,.18)" },
  "NEEDS ATTENTION":  { fg:"#f59e0b", bg:"rgba(245,158,11,.18)" },
  "RENEGOTIATION":    { fg:"#a855f7", bg:"rgba(168,85,247,.18)" },
  "INACTIVE":         { fg:"#8fa4c8", bg:"rgba(143,164,200,.14)" },
  "NOT STARTED":      { fg:"#8fa4c8", bg:"rgba(143,164,200,.14)" },
};

export const FINANCIAL_MAP = {
  "STABLE":           { fg:"#10c981", bg:"rgba(16,201,129,.18)" },
  "NEEDS_ATTENTION":  { fg:"#f04444", bg:"rgba(240,68,68,.18)"  },
  "Stable":           { fg:"#10c981", bg:"rgba(16,201,129,.18)" },
  "Needs Attention":  { fg:"#f04444", bg:"rgba(240,68,68,.18)"  },
};

export const SERVICE_MAP = {
  "CONSULTING":           { fg:"#60a5fa", bg:"rgba(96,165,250,.18)" },
  "VALUE SCAN":           { fg:"#10c981", bg:"rgba(16,201,129,.18)" },
  "TRANSFORMATION_SCAN":  { fg:"#a855f7", bg:"rgba(168,85,247,.18)" },
  "TRANSFORMATION SCAN":  { fg:"#a855f7", bg:"rgba(168,85,247,.18)" },
  "AI_PROJECT":           { fg:"#f59e0b", bg:"rgba(245,158,11,.18)" },
  "AI PROJECT":           { fg:"#f59e0b", bg:"rgba(245,158,11,.18)" },
};

export const PAYMENT_MAP = {
  "FIXED_PRICE":      { fg:"#a855f7", bg:"rgba(168,85,247,.18)" },
  "HOURLY_INVOICING": { fg:"#60a5fa", bg:"rgba(96,165,250,.18)" },
  "PRE_INVOICING":    { fg:"#f59e0b", bg:"rgba(245,158,11,.18)" },
  "HOURLY INVOICING": { fg:"#60a5fa", bg:"rgba(96,165,250,.18)" },
  "Fixed Price":      { fg:"#a855f7", bg:"rgba(168,85,247,.18)" },
  "Hourly Invoicing": { fg:"#60a5fa", bg:"rgba(96,165,250,.18)" },
  "Pre-Invoicing":    { fg:"#f59e0b", bg:"rgba(245,158,11,.18)" },
};

export const EMP_MAP = {
  "Full Time":  { fg:"#60a5fa", bg:"rgba(96,165,250,.18)" },
  "Talent Hub": { fg:"#a855f7", bg:"rgba(168,85,247,.18)" },
};

export const P_MAP = {
  P1: { fg:C.red,    bg:C.redB,    label:"P1 · Urgent"  },
  P2: { fg:C.yellow, bg:C.yellowB, label:"P2 · Monitor" },
  P3: { fg:C.green,  bg:C.greenB,  label:"P3 · Healthy" },
};

export const TASK_STATUS_STYLE = {
  "To Do":               { fg:"#8fa4c8", bg:"rgba(143,164,200,.18)" },
  "In Progress":         { fg:"#60a5fa", bg:"rgba(96,165,250,.18)"  },
  "Waiting on Internal": { fg:"#f59e0b", bg:"rgba(245,158,11,.18)"  },
  "Waiting on Client":   { fg:"#f8a853", bg:"rgba(248,168,83,.18)"  },
  "Blocked":             { fg:"#f04444", bg:"rgba(240,68,68,.18)"   },
  "Ready for Review":    { fg:"#a855f7", bg:"rgba(168,85,247,.18)"  },
  "Done":                { fg:"#10c981", bg:"rgba(16,201,129,.18)"  },
  "Cancelled":           { fg:"#8fa4c8", bg:"rgba(143,164,200,.14)" },
};

export const TASK_PRIO_STYLE = {
  "Critical": { fg:"#f04444", bg:"rgba(240,68,68,.18)"  },
  "High":     { fg:"#f59e0b", bg:"rgba(245,158,11,.18)" },
  "Medium":   { fg:"#60a5fa", bg:"rgba(96,165,250,.18)" },
  "Low":      { fg:"#8fa4c8", bg:"rgba(143,164,200,.18)"},
};

export const CUST_PRIO_STYLE = {
  "Escalated": { fg:"#f04444", bg:"rgba(240,68,68,.18)",  icon:"🔴" },
  "VIP":       { fg:"#f59e0b", bg:"rgba(245,158,11,.18)", icon:"⭐" },
  "Strategic": { fg:"#a855f7", bg:"rgba(168,85,247,.18)", icon:"◆"  },
  "Standard":  { fg:"#8fa4c8", bg:"rgba(143,164,200,.14)",icon:""   },
};

export const DEAL_CAT_STYLE = {
  "New Business":   { fg:"#60a5fa", bg:"rgba(96,165,250,.18)"  },
  "Existing Client":{ fg:"#10c981", bg:"rgba(16,201,129,.18)"  },
};

export const DEAL_TYPE_STYLE = {
  "New Business": { fg:"#60a5fa", bg:"rgba(96,165,250,.18)"  },
  "Expansion":    { fg:"#a855f7", bg:"rgba(168,85,247,.18)"  },
  "Renewal":      { fg:"#8fa4c8", bg:"rgba(143,164,200,.18)" },
};

export const TASK_CAT_STYLE = {
  Sales:    { fg:"#60a5fa", bg:"rgba(96,165,250,.18)"  },
  Customer: { fg:"#10c981", bg:"rgba(16,201,129,.18)"  },
  Projects: { fg:"#a855f7", bg:"rgba(168,85,247,.18)"  },
  Scoping:  { fg:"#f59e0b", bg:"rgba(245,158,11,.18)"  },
  Audit:    { fg:"#f43f5e", bg:"rgba(244,63,94,.18)"   },
};
